export const ACTION_TYPE_STOCK = "ACTION_TYPE_STOCK";
export const ACTION_TYPE_ATTRIBUTES = "ACTION_TYPE_ATTRIBUTES";